import type {
  BaseRawColumn as _BaseRawColumn,
  BuildDrizzleTable as _BuildDrizzleTable,
  BuildQueryJoinAliases as _BuildQueryJoinAliases,
  ChainedMethods as _ChainedMethods,
  ColumnToCodeConverter as _ColumnToCodeConverter,
  CountDistinct as _CountDistinct,
  CreateJSONQueryArgs as _CreateJSONQueryArgs,
  DeleteWhere as _DeleteWhere,
  DrizzleAdapter as _DrizzleAdapter,
  DrizzleTransaction as _DrizzleTransaction,
  DropDatabase as _DropDatabase,
  EnumRawColumn as _EnumRawColumn,
  Execute as _Execute,
  GenericColumn as _GenericColumn,
  GenericColumns as _GenericColumns,
  GenericPgColumn as _GenericPgColumn,
  GenericRelation as _GenericRelation,
  GenericTable as _GenericTable,
  IDType as _IDType,
  Insert as _Insert,
  IntegerRawColumn as _IntegerRawColumn,
  Migration as _Migration,
  PostgresDB as _PostgresDB,
  RawColumn as _RawColumn,
  RawForeignKey as _RawForeignKey,
  RawIndex as _RawIndex,
  RawRelation as _RawRelation,
  RawTable as _RawTable,
  RelationMap as _RelationMap,
  RequireDrizzleKit as _RequireDrizzleKit,
  SetColumnID as _SetColumnID,
  SQLiteDB as _SQLiteDB,
  TimestampRawColumn as _TimestampRawColumn,
  TransactionPg as _TransactionPg,
  TransactionSQLite as _TransactionSQLite,
  UUIDRawColumn as _UUIDRawColumn,
  VectorRawColumn as _VectorRawColumn,
} from '../types.js'

/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type BaseRawColumn = _BaseRawColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type BuildDrizzleTable = _BuildDrizzleTable
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type BuildQueryJoinAliases = _BuildQueryJoinAliases
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type ChainedMethods = _ChainedMethods
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type ColumnToCodeConverter = _ColumnToCodeConverter
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type CountDistinct = _CountDistinct
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type CreateJSONQueryArgs = _CreateJSONQueryArgs
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type DeleteWhere = _DeleteWhere
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type DrizzleAdapter = _DrizzleAdapter
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type DrizzleTransaction = _DrizzleTransaction
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type DropDatabase = _DropDatabase
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type EnumRawColumn = _EnumRawColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type Execute<T> = _Execute<T>
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type GenericColumn = _GenericColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type GenericColumns<T> = _GenericColumns<T>
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type GenericPgColumn = _GenericPgColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type GenericRelation = _GenericRelation
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type GenericTable = _GenericTable
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type IDType = _IDType
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type Insert = _Insert
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type IntegerRawColumn = _IntegerRawColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type Migration = _Migration
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type PostgresDB = _PostgresDB
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RawColumn = _RawColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RawForeignKey = _RawForeignKey
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RawIndex = _RawIndex
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RawRelation = _RawRelation
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RawTable = _RawTable
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RelationMap = _RelationMap
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type RequireDrizzleKit = _RequireDrizzleKit
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type SetColumnID = _SetColumnID
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type SQLiteDB = _SQLiteDB
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type TimestampRawColumn = _TimestampRawColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type TransactionPg = _TransactionPg
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type TransactionSQLite = _TransactionSQLite
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type UUIDRawColumn = _UUIDRawColumn
/**
 * @deprecated - import from `@payloadcms/drizzle` instead
 */
export type VectorRawColumn = _VectorRawColumn
